import { BathroomProductDto, InstallationType } from '../../tunnel/bathroom/bathroom-tunnel-dtos';

/**
 * DTO pour une composition de salle de bain
 */
export interface BathroomCompositionDto {
  id: string;
  name: string;
  thumbnailUrl: string;
  compositionConfigurationId?: string;
}

/**
 * DTO pour une composition avec détails complets (configuration, rows, columns)
 */
export interface BathroomCompositionDetailDto {
  id: string;
  name: string;
  thumbnailUrl: string;
  compositionConfigurationId?: string;
  compositionConfiguration?: CompositionConfigurationDto;
}

/**
 * DTO pour la configuration d'une composition (contient les lignes)
 */
export interface CompositionConfigurationDto {
  id: string;
  rows: CompositionRowDto[];
  rangeId: string;
  allowedBasinTypes?: string;
  hasElementRight: boolean;
  allowOffset: boolean;
  allowDoubleBasin: boolean;
  installationType: InstallationType;
  topRowWidths: string;
  bottomRowWidths: string;
  widthCombinations: string;
  handleConfigurationInfos: HandleConfigurationInfosDto;
}

/**
 * DTO pour une ligne de composition (contient les colonnes)
 */
export interface CompositionRowDto {
  id: string;
  index: number;
  coverProductId?: string;
  coverProduct?: BathroomProductDto;
  basinProductId: string;
  basinProduct: BathroomProductDto;
  width: number;
  offset: number;
  compositionConfigurationId: string;
  columns: CompositionColumnDto[];
  basinType?: BasinType;
}

/**
 * DTO pour une colonne de composition (contient un produit)
 */
export interface CompositionColumnDto {
  id: string;
  index: number;
  productId: string;
  product?: BathroomProductDto;
  handleId?: string;
  handle?: BathroomProductDto;
  width: number;
  compositionRowId: string;
  hasElementFix: boolean;
}

export enum BasinType {
  Simple = 1,
  Double = 2,
}

export enum DrawerCount {
  Simple = 0,
  Double = 1,
}

/**
 * Filtres pour la recherche de compositions
 */
export interface CompositionFilters {
  /** Superficie de la salle de bain en m² */
  bathroomArea: number;
  /** Dimensions max souhaitées du meuble en cm */
  maxFurnitureWidth: number;
  /** Nombre de tiroirs: 'simple', 'double', ou null pour sans préférence */
  drawerCount?: DrawerCount | null;
  /** Type de vasque: 'simple', 'double', ou null pour sans préférence */
  withNiche?: boolean | null;
}

export const DEFAULT_COMPOSITION_FILTERS: CompositionFilters = {
  bathroomArea: 20,
  maxFurnitureWidth: 120,
  drawerCount: null,
  withNiche: null,
};

/**
 * Infos sur les poignées
 */
export interface HandleConfigurationInfosDto {
  id: string;
  availableHandles: AvailableHandleDto[];
}
/**
 * Infos par type poignées
 */
export interface AvailableHandleDto {
  id: string;
  index: number;
  name: string;
  installationType: InstallationType;
  imageUrl: string;
  possibleDimensions?: string;
  handleConfigurationInfosId: string;
  handleConfigurationInfos?: HandleConfigurationInfosDto;
}
